import React from "react";
import { useForm } from "react-hook-form";
import { Container, Paper, Button, Grid, Box, Typography, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../../logoCC.png";
import logoSm from "../../logo.png";

const ClaimNumber = ({ setNSiniestro, setIsAdmin }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = (data) => {
    setNSiniestro(data.nSiniestro);
    setIsAdmin(true);
    console.log("Número de siniestro enviado:", data.nSiniestro);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, textAlign: "center", width: "100%" }}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <img src={logoSm} alt="logoSm" width={60} />
          <Typography variant="h5" sx={{ mt: 2, fontFamily: "'Inter', sans-serif" }}>
            Introduce el Nº de Siniestro
          </Typography>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <TextField
            {...register("nSiniestro", {
              required: "El número de siniestro es obligatorio",
            })}
            label="Nº de siniestro"
            fullWidth
            error={!!errors.nSiniestro}
            helperText={errors.nSiniestro?.message}
            sx={{ my: 2 }}
          />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                component={Link}
                to="/forms"
                variant="outlined"
                color="secondary"
                fullWidth
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Continuar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
      <div style={{textAlign: "center", marginTop: "10px"}}>
        <img src={logo} alt="Logo CodeCanario" width={120}/>
      </div>
    </Container>
  );
};

export default ClaimNumber;
